import type { GoogleMap } from '@lib/geo/google/map';

import { IFsMap } from '../types';

export abstract class FsMapOffendersServiceProvider<TMap extends IFsMap> {
  public abstract get isAvailable(): boolean;
  public abstract offenderClustering: boolean;

  public abstract onMapLoaded(map: TMap): void;
  public abstract select(): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
  public abstract viewOffender(id: string): void;
  public abstract setOffenderClustering(enabled: boolean): void;
}
